export const NAV_LINKS = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Demo', href: '/demo' },
]

export const PRODUCT_LINKS = [
  {
    label: 'Projects',
    href: '/projects',
    kicker: 'Project controls',
    description: 'Schedule, cost, procurement, and risk for the PM command center.',
    status: 'Platform',
  },
  {
    label: 'Benchmark',
    href: '/benchmark',
    kicker: 'Quality control',
    description: 'QC plans, inspections, NCRs, and audit-ready quality records.',
    status: 'Queued',
  },
  {
    label: 'Design',
    href: '/design',
    kicker: 'Drawing repository',
    description: 'Current revisions, document workflows, and one source of truth.',
    status: 'Roadmap',
  },
  {
    label: 'Pro',
    href: '/pro',
    kicker: 'Field operations',
    description: 'Crew management, safety, daily reports, and field execution.',
    status: 'Live',
  },
]

export const APP_REGISTER_URL = 'https://app.sitedeck.pro/register'
